/**
 * Connected user plus role flags used by pickers and page gates.
 */

import { useAuthStore } from '@/stores/authStore';
import { useMode } from '@/contexts/ModeContext';
import { roleKind } from '@/utils/role-label-utils';

/** Derives role booleans from {@link useAuthStore} and the validated-prospection establishment picker gate. */
export function useConnectedUser() {
  const { user, roles, isAuthenticated } = useAuthStore();
  const { mode } = useMode();

  const isVolunteer = roles.some((r) => roleKind(r.code) === 'volunteer');
  const isVsc = roles.some((r) => roleKind(r.code) === 'vsc');
  const isTutor = roles.some((r) => roleKind(r.code) === 'tutor');
  const isStudent = roles.some((r) => roleKind(r.code) === 'student');
  const isAdmin = roles.some((r) => roleKind(r.code) === 'admin');
  const isManager = roles.some((r) => roleKind(r.code) === 'manager');
  const isCoordinator = roles.some((r) => roleKind(r.code) === 'coordinator');
  /** In-person coordinator/manager pickers: only establishments with validated prospection. */
  const limitEstablishmentPickerToValidated = mode === 'in_person' && (isManager || isCoordinator);

  return {
    user,
    roles,
    isAuthenticated,
    isVolunteer,
    isVsc,
    isTutor,
    isStudent,
    isAdmin,
    isManager,
    isCoordinator,
    limitEstablishmentPickerToValidated,
  };
}
